export class AutoplayHandlerEvents {
	public static readonly START_AUTOPLAY_SPIN: string = 'AutoplayHandlerEvents::START_AUTOPLAY_SPIN';

	public static readonly AUTOPLAY_ROUNDS_FINISHED: string = 'AutoplayHandlerEvents::AUTOPLAY_ROUNDS_FINISHED';

	public static readonly AUTOPLAY_STOPPED: string = 'AutoplayHandlerEvents::AUTOPLAY_STOPPED';
	public static readonly AUTOPLAY_STOPPED_ON_WIN_LIMIT: string = 'AutoplayHandlerEvents::AUTOPLAY_STOPPED_ON_WIN_LIMIT';
	public static readonly AUTOPLAY_STOPPED_ON_LOSE_LIMIT: string = 'AutoplayHandlerEvents::AUTOPLAY_STOPPED_ON_LOSE_LIMIT';
	public static readonly AUTOPLAY_STOPPED_ON_SINGLE_WIN_LIMIT: string = 'AutoplayHandlerEvents::AUTOPLAY_STOPPED_ON_SINGLE_WIN_LIMIT';
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/autoplay/AutoplayHandlerEvents.ts